import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'core-js/modules/es.symbol.description.js';
import 'core-js/modules/es.error.cause.js';
import 'core-js/modules/es.array.reduce.js';
import React from 'react';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import isMap from 'lodash/isMap';
import { jsx } from 'react/jsx-runtime';
const getIconComponent = (id, iconSet) => get(iconSet, id, null);
const buildComponent = (Component, props) => /*#__PURE__*/jsx(Component, _objectSpread({}, props));
const IconFactory = iconSet => {
  const icons = iconSet.reduce((acc, i) => {
    acc[i.ICON_ID] = i;
    return acc;
  }, {});
  return (icon, propsOrclassName) => {
    let className;
    let props;
    if (typeof propsOrclassName === 'string') {
      // es un className
      className = propsOrclassName;
    } else if (isMap(propsOrclassName) || isObject(propsOrclassName)) {
      className = propsOrclassName.className;
      props = propsOrclassName;
    }
    if ( /*#__PURE__*/React.isValidElement(icon)) {
      return /*#__PURE__*/React.cloneElement(icon, {
        className
      });
    }
    if (!isArray(iconSet)) {
      throw new Error('Bad Parameter, array expected');
    }
    let id;
    if (typeof icon === 'string') {
      id = icon.toLowerCase();
    } else if (isObject(icon) && typeof icon.id === 'string') {
      id = icon.id.toLowerCase();
    } else {
      return null;
    }
    const Component = getIconComponent(id, icons);
    if (!Component) {
      return null;
    }
    return buildComponent(Component, _objectSpread(_objectSpread({}, props), {}, {
      className,
      description: icon.description
    }));
  };
};
var factoryBuilder = iconSet => IconFactory(iconSet);
export { factoryBuilder as default };
